/**
 * Under Construction Component
 * Generic page for unimplemented features
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './UnderConstruction.css';

const UnderConstruction = ({ sectionName, sectionIcon = '🚧' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="under-construction">
      <div className="under-construction-content">
        <div className="under-construction-icon">
          {sectionIcon}
        </div>
        
        <h1 className="under-construction-title">
          {sectionName || t('underConstruction.title')}
        </h1>
        
        <p className="under-construction-message">
          {t('underConstruction.message')}
        </p>
        
        <div className="under-construction-details">
          <p>{t('underConstruction.details')}</p>
          <ul className="under-construction-features">
            <li>{t('underConstruction.feature1')}</li>
            <li>{t('underConstruction.feature2')}</li>
            <li>{t('underConstruction.feature3')}</li>
          </ul>
        </div>

        <div className="under-construction-actions">
          <button
            className="btn btn-primary"
            onClick={() => navigate('/dashboard')}
          >
            {t('underConstruction.backToDashboard')}
          </button>
          
          <button
            className="btn btn-outline-secondary"
            onClick={() => navigate(-1)}
          >
            {t('underConstruction.goBack')}
          </button>
        </div>

        <div className="under-construction-footer">
          <p className="text-muted">
            {t('underConstruction.contact')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;
